import type { DayObject } from 'types/graphql'
import { isUUID } from 'validator'

export enum DayObjectVariants {
  CHIP = 'CHIP',
  TILE = 'TILE',
}

export const getPropertyValue = (
  object: DayObject,
  propertyDefinitionId: string
) => {
  if (!object) return null

  const propType = isUUID(propertyDefinitionId) ? 'custom' : 'standard'
  return object?.properties?.[propType]?.[propertyDefinitionId]?.value
}
